import { render, staticRenderFns } from "./FamilyModal.vue?vue&type=template&id=6a49dd2c&scoped=true"
import script from "./FamilyModal.vue?vue&type=script&lang=js"
export * from "./FamilyModal.vue?vue&type=script&lang=js"
import style0 from "./FamilyModal.vue?vue&type=style&index=0&id=6a49dd2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a49dd2c",
  null
  
)

export default component.exports